export default "__VITE_ASSET__C3kdvWsh__"